import { EnvMicroReport } from 'lib-klab-core';

export const envReportLocal: EnvMicroReport = {
    host: '',
    apiBasePath: '/ms-report',
    vars: {},
    useMocks: false,
    mock: {
        appActivityReports: {
            getAppActivitiesList: false,
            getAppsTopWithPercentage: false,
        },
        webActivityReports: {
            getWebActivitiesList: false,
            getWebsTopWithPercentage: false,
        },
        connectivityReports: {
            getConnectivityReport: false
        },
        timeSheetReports: {
            getTimeSheet: false
        },
        keystrokeReports: {
            getEmployeeKeystrokes: false
        }
    },
};

export const envReportDev: EnvMicroReport = {
    host: 'https://gatewayapi-dev.klab.inclub.world',
    apiBasePath: '/ms-report',
    vars: {},
    useMocks: false,
    mock: {
        appActivityReports: {
            getAppActivitiesList: false,
            getAppsTopWithPercentage: false,
        },
        webActivityReports: {
            getWebActivitiesList: false,
            getWebsTopWithPercentage: false,
        },
        connectivityReports: {
            getConnectivityReport: false
        },
        timeSheetReports: {
            getTimeSheet: false
        },
        keystrokeReports: {
            getEmployeeKeystrokes: false
        }

    },
};

export const envReportProd: EnvMicroReport = {
    host: 'https://gatewayapi.klab.inclub.world',
    apiBasePath: '/ms-report',
    vars: {},
    useMocks: false,
};
